import React, { useState } from 'react'
import { makeStyles, Tab, Tabs, Typography } from '@material-ui/core'
import { useTranslate } from 'react-admin'
import { USER_ADDONS } from '../../../utils/constants/userAddons'
import ORGANISATION_TYPES from '../../../utils/constants/OrganisationTypes'
import localStorageIds from '../../../utils/constants/localStorageIds'
import useGetLocalStorage from '../../../hooks/useGetLocalStorage'
import CardWrapperMoreIcon from '../../../components/layout/CardWrapperMoreIcon/CardWrapperMoreIcon'
import FansChannelsPage from '../../Fans/FansChannelsPage/FansChannelsPage'
import SocialChannelsTab from '../SocialChannelsTab/SocialChannelsTab'

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(3) },
  title: { marginBottom: theme.spacing(1) },
  tabs: { marginBottom: theme.spacing(3), borderBottom: `1px solid ${theme.palette.divider}` },
  panel: {},
}))

// Distribution page (BUS-2799 / PNP-WEB-01, reworked): per-competition Fans + Social channels
// under one tabbed page. Replaces the old per-org Meta integration card + config form (the
// server-side config/posting was retired in the Engage refactor). Each tab shows only when the
// org has the matching addon.
const DistributionPage = () => {
  const classes = useStyles()
  const translate = useTranslate()
  const localStorageValue = useGetLocalStorage()
  const { [localStorageIds.SELECTED_ORG]: selectedOrg } = localStorageValue || {}

  const hasAddon = (addon) => selectedOrg?.addons?.includes(addon)
  // Per-competition social is federation-only; clubs connect their org-level Meta account on the
  // Integrations page instead.
  const isFederation = selectedOrg?.type === ORGANISATION_TYPES.ORG_FEDERATION

  const tabs = [
    hasAddon(USER_ADDONS.FANS) && { key: 'fans', label: translate('ra.buttons.fans') },
    isFederation &&
      hasAddon(USER_ADDONS.ENGAGE) && { key: 'social', label: translate('ra.buttons.social') },
  ].filter(Boolean)

  const [tabIndex, setTabIndex] = useState(0)
  const activeKey = tabs[tabIndex]?.key || tabs[0]?.key

  return (
    <CardWrapperMoreIcon>
      <div className={classes.root}>
        <Typography variant='h5' className={classes.title}>
          {translate('ra.page.distribution')}
        </Typography>

        {tabs.length > 1 && (
          <Tabs
            className={classes.tabs}
            value={tabIndex}
            onChange={(_e, value) => setTabIndex(value)}
            indicatorColor='primary'
            textColor='primary'
          >
            {tabs.map((tab) => (
              <Tab key={tab.key} label={tab.label} />
            ))}
          </Tabs>
        )}

        <div className={classes.panel}>
          {activeKey === 'fans' && <FansChannelsPage />}
          {activeKey === 'social' && <SocialChannelsTab />}
        </div>
      </div>
    </CardWrapperMoreIcon>
  )
}

export default DistributionPage
